"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedStoreEventsContext = exports.useSharedStoreEventsContext = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const operators_1 = require("rxjs/operators");
const shared_values_model_1 = require("../shared-values.model");
const operators_2 = require("../../operators");
function useSharedStoreEventsContext(values) {
    return react_1.useMemo(() => new SharedStoreEventsContext(values), [values]);
}
exports.useSharedStoreEventsContext = useSharedStoreEventsContext;
const NoOpCriteria = () => true;
class SharedStoreEventsContext {
    constructor(context) {
        this.context = context;
    }
    waitForNext(event, filter) {
        const criteria = filter || NoOpCriteria;
        const stream = this.stream(event);
        return stream.pipe(operators_2.waitForNext(criteria)).toPromise();
    }
    on(event, listener) {
        const stream = this.stream(event);
        const sub = stream.subscribe(listener);
        return () => sub.unsubscribe();
    }
    stream(eventType) {
        const stream = this.context.get(shared_values_model_1.APP_EVENTS, eventType);
        return stream.pipe(operators_1.map(event => event.payload));
    }
    dispatch(type, payload) {
        const stream = this.context.get(shared_values_model_1.APP_EVENTS, type);
        react_dom_1.unstable_batchedUpdates(() => stream.next({ type, payload }));
    }
}
exports.SharedStoreEventsContext = SharedStoreEventsContext;
//# sourceMappingURL=events-context.js.map